import { useCallback, useEffect, useState } from "react";

import httpclient from "../Utils";
import useTokenRefresh from "./useTokenRefresh";
import { useApiErrorHandler } from "./useApiErrorHandler";

export const useDevices = (initialType = "all") => {
  const [devices, setDevices] = useState([]);
  const [pickers, setPickers] = useState([]);
  const [type, setType] = useState(initialType);
  const [loading, setLoading] = useState(false);

  const { getTokenRefreshed: refresh } = useTokenRefresh();
  const handleApiError = useApiErrorHandler();

  const getDevices = useCallback(async () => {
    setLoading(true);
    const API_URL = `devices/${type}`;

    try {
      const res = await httpclient.get(API_URL);
      const { data } = res;

      if (data.status === 200) {
        setDevices(data.data);
        setPickers(data.users); // Only Pickers and Packers
      }
    } catch (error) {
      // handleApiError(error);
    } finally {
      setLoading(false);
    }
  }, [type]);

  useEffect(() => {
    getDevices();
  }, [type, getDevices]);

  return { devices, pickers, type, setType, loading };
};
